import { NgxLoggerLevel } from 'ngx-logger';

export const environment = {
    production: false,
    apiBase: 'https://app.teamstreamz.com/api/v3',
    title: 'Streamz AI Admin Panel',
    loginTitle: 'Sign In - Streamz AI Admin',
    logLevel: NgxLoggerLevel.LOG,
    serverLogLevel: NgxLoggerLevel.OFF,
    routeTracing: false,
    googleMapsAPIKey: 'AIzaSyC0wrPFTvQtRYcargsc_xIH6zWd1HY9odQ',
    timeout: 360000,
    aiApiBase: 'https://525.teamstreamz.com/api/admin/ai',
    firebase: {
        apiKey: 'AIzaSyBmPnPTG-lbKwql51-U6eNZlPhrgHwWu_Y',
        authDomain: 'ts-android-c38e0.firebaseapp.com',
        databaseURL: 'https://ts-android-c38e0.firebaseio.com',
        projectId: 'ts-android-c38e0',
        storageBucket: 'ts-android-c38e0.appspot.com',
        messagingSenderId: '819211248292',
        appId: '1:819211248292:web:74a344eadc65c07da67c31',
        measurementId: 'G-RF752H2XZV'
    },
    vapidKey:
        'BH3Nza3mMFdq9eaZCnVXuIyh4XdGVLiRZubG4D2WdhEH0PpIYGpmBF6mNOW7O2EU53xrH4TxeQdyzuYcikQdhoU'
};
